import { cn } from "@/lib/utils";

interface GlassSkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
  intensity?: "light" | "medium" | "strong";
}

/**
 * Glassmorphism Skeleton Component with shimmer effect
 * 
 * Features:
 * - NO backdrop-blur - removed to prevent 2s blur during tab transitions
 * - Animated shimmer gradient
 * - Matches glassmorphism card design
 */
function GlassSkeleton({ className, intensity = "medium", ...props }: GlassSkeletonProps) {
  const intensities = {
    light: "bg-card/40",
    medium: "bg-card/60",
    strong: "bg-card/80",
  };

  return (
    <div
      className={cn(
        "relative overflow-hidden rounded-md",
        intensities[intensity],
        // NO backdrop-blur - causes navigation blur issues
        "border border-border/20",
        // Shimmer effect
        "before:absolute before:inset-0",
        "before:bg-gradient-to-r",
        "before:from-transparent before:via-white/10 before:to-transparent",
        "before:animate-[shimmer_2s_infinite]",
        className
      )}
      {...props}
    />
  );
}

export { GlassSkeleton };
